import React from 'react'
import EditableText from '@/components/editable/EditableText'

const PUBLICS = [
  {
    t: 'Jeunes',
    d: "Découverte des métiers modernes, IA, expression artistique, accompagnement à la transition. Pour les jeunes en rupture, en difficulté ou en quête de sens.",
    projection: "Recréer du mouvement, remettre en action, découvrir de nouveaux outils et retrouver progressivement confiance dans ses capacités.",
    age: '14 — 25',
  },
  {
    t: 'Adultes en transition',
    d: "Reconversion, reconnexion, intelligence émotionnelle, créativité. Reprendre confiance pour entreprendre et oser un nouveau chapitre professionnel.",
    projection: "Repenser son parcours, explorer de nouvelles voies et reconnecter compétences, sens et créativité.",
    age: '25 — 55',
  },
  {
    t: 'Professionnels',
    d: "Acquérir les compétences essentielles pour créer, produire et entreprendre avec les outils de l'IA d'aujourd'hui. Formations courtes et immersions.",
    projection: "Comprendre les transformations liées à l'IA et développer des compétences immédiatement applicables dans le monde actuel.",
    age: 'Tous âges',
  },
  {
    t: 'Artistes & créateurs',
    d: "Un laboratoire vivant pour expérimenter, collaborer, exposer. Un incubateur humain au croisement des arts, du numérique et de la transmission.",
    projection: "Expérimenter dans un cadre vivant où la création, la transmission et l'innovation peuvent se rencontrer librement.",
    age: 'Sur sélection',
  },
]

const Publics: React.FC = () => {
  return (
    <section id="publics" className="relative bg-[#14253B] py-32 lg:py-44">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-20">
          <div className="lg:col-span-4 reveal">
            <div className="text-[10px] tracking-luxe text-[#C8A24A] mb-4">
              <EditableText as="span" contentKey="publics.section.kicker" section="Publics" label="Numéro de section">04 — PUBLICS</EditableText>
            </div>
            <div className="divider-gold w-24 mb-6" />
            <EditableText contentKey="publics.kicker" section="Publics" label="Sous-titre" as="div" className="text-[12px] tracking-mid uppercase text-[#C9BFA8]">
              Pour qui le Centre s'adresse
            </EditableText>
          </div>
          <div className="lg:col-span-8 reveal">
            <h3 className="font-serif-display text-[36px] sm:text-[48px] lg:text-[60px] leading-[1.05] text-[#E8DCC4] text-balance">
              <EditableText contentKey="publics.title" section="Publics" label="Titre principal" as="span">
                Différents publics, différentes générations, une même dynamique de transformation.
              </EditableText>
            </h3>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-px bg-[rgba(232,220,196,0.10)] hairline">
          {PUBLICS.map((p, i) => (
            <div
              key={p.t}
              className="bg-[#14253B] p-10 lg:p-14 reveal group hover:bg-[#161e22] transition-colors duration-500 relative"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-baseline justify-between mb-8">
                <div className="font-serif-display text-[14px] italic text-[#C9E26A]">
                  <EditableText contentKey={`publics.item${i}.age`} section="Publics" label={`${p.t} — Âge`} as="span">{p.age}</EditableText>
                </div>
                <div className="w-12 h-px bg-[#C8A24A]/40 group-hover:w-20 group-hover:bg-[#C9E26A] transition-all duration-500" />
              </div>
              <h4 className="font-serif-display text-[40px] lg:text-[52px] leading-[1] text-[#E8DCC4] mb-6">
                <EditableText contentKey={`publics.item${i}.titre`} section="Publics" label={`${p.t} — Titre`} as="span">{p.t}</EditableText>
              </h4>
              <p className="text-[15px] leading-[1.75] text-[#C9BFA8] max-w-md">
                <EditableText contentKey={`publics.item${i}.d`} section="Publics" label={`${p.t} — Description`} multiline as="span">
                  {p.d}
                </EditableText>
              </p>
              <div className="mt-5 flex items-start gap-3 max-w-md">
                <span className="mt-2.5 w-3 h-px bg-[#C9E26A] shrink-0" />
                <p className="text-[13.5px] italic leading-[1.7] text-[#C9E26A]/90">
                  <EditableText contentKey={`publics.item${i}.projection`} section="Publics" label={`${p.t} — Projection`} multiline as="span">
                    {p.projection}
                  </EditableText>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Publics
